import axios from 'axios';
import { URL_AUTH, URLAPI } from '../../Setting';
import { Identifiant } from '../../Models/Identifiant/IdentifiantModels';

export function loginService(){
  return {
    /*
    async getIdentifiant(token:any){
      try {
        const response = await axios.get(`${URLAPI}identifiants`, {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type":"application/ld+json"
          },
        });
        const dataIdentifiant = response.data['hydra:member'][0]
        let identifiantUpdate:Identifiant = {
          id:dataIdentifiant['id'], 
          userIdentifier:dataIdentifiant['userIdentifier'], 
          actif:dataIdentifiant['actif'], 
          role:dataIdentifiant['role'],
          clients:dataIdentifiant['clients'].map((client:any)=>{return {'@id':client}})
        }
        return identifiantUpdate;
      } catch (error) {
        return 404
      } 
    },
    */
    async getIdentifiant(token:any, login?:string){
      try {
        const response = await axios.get(`${URLAPI}identifiants`, {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type":"application/ld+json"
          },
        });

        // TEMPORAIRE : la collection n'est plus filtree sur le porteur du token.
        // On selectionne le compte correspondant au login saisi au lieu du premier
        // element, qui est systematiquement le compte admin (id 1).
        // A remplacer par GET identifiant/me des que l'endpoint est disponible.
        const membres = response.data['hydra:member'] ?? [];
        const dataIdentifiant = login
          ? membres.find((membre:any) =>
              String(membre['login']).toLowerCase() === login.toLowerCase())
          : undefined;

        if(!dataIdentifiant) return 404;

        const roles:string[] = dataIdentifiant['roles'] ?? [];
        const identifiantUpdate:Identifiant = {
          id: dataIdentifiant['id'],
          userIdentifier: dataIdentifiant['login'],
          role: roles.includes('ROLE_ADMIN') ? 'ROLE_ADMIN' : 'ROLE_USER',
          clients: (dataIdentifiant['clients'] ?? []).map((client:any)=>({'@id':client}))
        };
        return identifiantUpdate;
      } catch (error) {
        return 404;
      }
    },

    async getTokenConnection(id:string, password:string){
      try {
        const response = await axios.post(
          `${URL_AUTH}`,
          { login: id, password: password },
          {
            headers: {
              'Content-Type': 'application/json',
            },
          }
        );
  
        const dataToken = response.data.token;
        if (response.status === 200) {
          return dataToken;
        }
      } catch (error) {
        if (axios.isAxiosError(error)) {
          if (error.response?.status === 401) {
            return 401;
          } else if (error.response?.status === 400) {
            return 400;
          }
        } else {
          console.error('Error:', error);
          return 1
        }
      } 
    },
  }
}
